import * as XLSX from 'xlsx';
import { tableToIPC, tableFromJSON, Table } from 'apache-arrow';
import initWasm, { WriterPropertiesBuilder, Table as WasmTable, writeParquet } from 'parquet-wasm';

let wasmInitialized = false;

export const convertXlsxToParquet = async (file: File): Promise<File> => {
  if (!wasmInitialized) {
    await initWasm();
    wasmInitialized = true;
  }

  const arrayBuffer = await file.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: 'array' });
  const sheetName = workbook.SheetNames[0];
  const sheet = workbook.Sheets[sheetName];

  const jsonData = XLSX.utils.sheet_to_json<Record<string, unknown>>(sheet);

  if (jsonData.length === 0) {
    throw new Error('A planilha está vazia');
  }

  // Converte todos os valores para string para simplificar tipagem
  const stringData = jsonData.map((row) => {
    const newRow: Record<string, string> = {};
    for (const [key, value] of Object.entries(row)) {
      newRow[key] = value != null ? String(value) : '';
    }
    return newRow;
  });

  // Cria tabela Arrow e serializa para IPC
  const arrowTable: Table = tableFromJSON(stringData);
  const ipcBytes = tableToIPC(arrowTable);

  // Converte IPC para Parquet via WASM
  const wasmTable = WasmTable.fromIPCStream(ipcBytes);
  const writerProperties = new WriterPropertiesBuilder().build();
  const parquetBuffer = writeParquet(wasmTable, writerProperties);

  const fileName = file.name.replace(/\.xlsx?$/i, '.parquet');
  return new File([new Uint8Array(parquetBuffer)], fileName, {
    type: 'application/vnd.apache.parquet',
  });
};
